<div class="table-sort-mode">
  <mat-form-field data-test="table-sort-mode__form-field" appearance="fill" subscriptSizing="dynamic">
    <mat-label>{{ 'app.catalog.filter.sorting.label' | translate }}</mat-label>
    <mat-select data-test="table-sort-mode__select" [formControl]="tableSortModeControl">
      <mat-option *ngFor="let sortOption of sortOptions" [value]="sortOption.value">
        {{ 'app.catalog.filter.sorting.option.' + sortOption.key | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
